/**
 * Serialises terminal input: at most one POST in flight. Keystrokes typed
 * while one is in flight are joined into a pending buffer and sent as ONE
 * request when the current one settles, so bytes can never reach the shell
 * out of order (independent POSTs race through DB + DNS + TLS and 2 replicas).
 * A failed send is reported through `onError` and does not stall the queue:
 * the next batch still goes out, in order.
 */
export function createInputQueue(
  send: (data: string) => Promise<unknown>,
  onError: (err: unknown) => void,
): { push: (data: string) => void } {
  let inFlight = false;
  let pending = '';

  function flush(): void {
    if (inFlight || pending === '') return;
    const batch = pending;
    pending = '';
    inFlight = true;
    let p: Promise<unknown>;
    try {
      p = send(batch);
    } catch (err) {
      p = Promise.reject(err);
    }
    void p
      .catch(onError)
      .finally(() => {
        inFlight = false;
        flush();
      });
  }

  return {
    push(data: string) {
      pending += data;
      flush();
    },
  };
}
